module.exports = __webpack_public_path__ + "static/media/mercy.332e4960.png";